// ./src/utils/recordRights.ts
//
// Per-record rights returned by the API on read outputs (`rights: string[]`) —
// the actions the current caller may perform on THAT specific record. Use this
// to show/hide row action buttons (edit / remove / duplicate) per record, on top
// of the page-level right checks (hasRightTo).

export type RecordRight = "edit" | "remove" | "duplicate";

/**
 * Whether the record grants the given right to the current caller.
 *
 * Fail-open: a record with no `rights` array (older API build, or a code path
 * that doesn't return it) is treated as allowed, so behaviour is unchanged until
 * the server actually sends rights. Once `rights` is present, it's authoritative.
 */
export const recordHasRight = (
  record: { rights?: string[] | null } | null | undefined,
  right: RecordRight
): boolean => {
  const rights = record?.rights;

  if (!rights) {
    return true;
  }

  return rights.includes(right);
};
